var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customFieldLabelAndValue"},[(_vm.customField.show_label)?_c('div',{staticClass:"custom-field-label"},[_vm._v("\n    "+_vm._s(_vm.customField.label)+"\n  ")]):_vm._e(),_c('div',{staticClass:"custom-field-value-string"},[_c('custom-field-value-string',{attrs:{"value":_vm.value,"custom-field":_vm.customField}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }